module.exports = __webpack_public_path__ + "img/back-white.149673ed.svg";